export default __webpack_public_path__ + "static/media/gasInActiveIcon.a2e5ece3.svg";